import { InternalApiUserBasicDetailsWithRoles } from '../api-internal';

const READ_ONLY_ROLES = [
  'IT_ADMIN',
  'CUSTOMER_READONLY',
  'CUSTOMER_DASHBOARD_READONLY',
  'SCREENING_SEARCH_ONLY',
  'GLOBAL_ENGINEER',
];

export const isUserAssignable = (userRoles?: string[]): boolean => {
  if (!userRoles || userRoles.length === 0) {
    return false;
  }
  return userRoles.some((role) => !READ_ONLY_ROLES.includes(role));
};

export const filterAssignableUsers = (
  users?: InternalApiUserBasicDetailsWithRoles[]
): InternalApiUserBasicDetailsWithRoles[] => {
  if (!users) {
    return [];
  }
  return users.filter((user) => isUserAssignable(user.roles));
};
